<template>
  <v-card class="elevation-0">
    <v-card-title class="pb-0 pr-0">
      <div>
        <div class="title">{{ achievement.title }}</div>
        <div class="subheading grey--text" v-if="achievement.achievedAt">
          {{ new Date(achievement.achievedAt) | date('d MMMM yyyy') }}
        </div>
      </div>

      <v-spacer />

      <can I="edit" a="Profile">
        <v-btn small flat fab color="error" icon @click="remove(achievement.id)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </can>

      <can I="edit" a="Profile">
        <v-dialog v-model="editing" max-width="600">
          <v-btn
            slot="activator"
            small flat fab
            color="secondary"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-card dark>
            <v-card-title class="title">
              Editing merit
            </v-card-title>
            <v-card-text>
              <v-form v-model="valid">
                <v-text-field
                  label="Title"
                  v-model="achievement.title"
                  required :rules="rules.title"
                  :counter="128"
                />
                <v-textarea
                  label="Description"
                  v-model="achievement.description"
                  :rules="rules.description"
                  :counter="512" auto-grow
                />
                <date-picker
                  label="Achieved"
                  v-model="achievement.achievedAt"
                  append-icon="mdi-calendar"
                  :rules="rules.achievedAt"
                  clearable
                />
              </v-form>
            </v-card-text>
            <v-card-actions><v-spacer />
              <v-btn flat @click="editing = false && $emit('cancel')" color="grey">
                cancel
              </v-btn>
              <v-btn color="primary" :disabled="!valid" @click="update(achievement.id)">Update</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </can>
    </v-card-title>
    <v-card-text v-if="achievement.description" class="pt-0">
      {{ achievement.description }}
    </v-card-text>
  </v-card>
</template>

<script>
// Vue Component
export default {
  props: {
    achievement: Object
  },
  data() {
    return {
      editing: false,
      valid: true,
      rules: {
        title: [
          v => !!v || 'You must specify a title',
          v => {
            return !v || (v && v.length < 128) || 'This must be less than 128 characters'
          }
        ],
        description: [
          v => {
            return !v || (v && v.length < 512) || 'This must be less than 512 characters'
          }
        ],
        achievedAt: []
      }
    }
  },
  methods: {
    update(id) {
      this.$store.dispatch('admin/achievements/update', this.achievement).then(
        // Success
        () => {
          this.$store.commit('snackbar', {
            text: 'Merit was updated successfully',
            type: 'success'
          })
          this.$store.dispatch('admin/profiles/fetch', this.$route.params.id)
          this.editing = false
        },
        // Failure
        () => {
          this.$store.commit('snackbar', {
            text: 'Merit could not be updated',
            type: 'error'
          })
        }
      )
    },
    remove(id) {
      this.$store.dispatch('admin/achievements/destroy', id).then(
        // Success
        response => {
          this.$store.commit('snackbar', {
            text: 'Merit was removed successfully',
            type: 'success'
          })
          this.$store.dispatch('admin/profiles/fetch', this.$route.params.id)
        },
        // Failure
        errors => {
          this.$store.commit('snackbar', {
            text: 'Merit could not be removed',
            type: 'error'
          })
        }
      )
    }
  }
}
</script>
